import React, {useContext} from "react";
import {FormInstance} from "antd/lib/form/Form"

const abc = 123

export default abc

export const SetupContext = React.createContext<{
    form?: FormInstance;
    page: string;
    setPage: (value: string) => void;
}>({
    form: undefined,
    page: "setup",
    setPage: () => {}
})


export const useSetupContext = () => {
    const {form, ...rest} = useContext(SetupContext)

    if (!form) {
        throw new Error("Form is not setup yet.")
    }

    return {form, ...rest}
}